/**
 * Card Swatch Selector
 * Handles click events on product card swatches to update the card image
 * without navigating to the product page.
 */

class CardSwatchSelector {
  constructor() {
    this.init();
  }

  init() {
    // Use event delegation on the document for dynamically loaded cards
    // Using capture phase to ensure we get the click before any other handlers
    document.addEventListener('click', this.handleSwatchClick.bind(this), true);
  }

  handleSwatchClick(event) {
    const swatchButton = event.target.closest('.card__swatch-button');
    if (!swatchButton || swatchButton.disabled) return;

    // Prevent any default behavior and stop propagation immediately
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    // Get the card wrapper
    const cardWrapper = swatchButton.closest('.card-wrapper');
    if (!cardWrapper) return;

    // Get the image element to update
    const cardImage = cardWrapper.querySelector('.card__media-image');
    if (!cardImage) return;

    // Get image data from the swatch button
    const newSrc = swatchButton.dataset.variantImageSrc;
    const newSrcset = swatchButton.dataset.variantImageSrcset;
    const newAlt = swatchButton.dataset.variantImageAlt;

    if (!newSrc) return;

    // Update image attributes
    cardImage.src = newSrc;
    if (newSrcset) {
      cardImage.srcset = newSrcset;
    }
    if (newAlt) {
      cardImage.alt = newAlt;
    }

    // Update active state on swatches
    const swatchContainer = swatchButton.closest('.card__swatches');
    if (swatchContainer) {
      // Remove active class from all swatches in this card
      swatchContainer.querySelectorAll('.card__swatch-button').forEach((btn) => {
        btn.classList.remove('card__swatch-button--active');
      });
      // Add active class to clicked swatch
      swatchButton.classList.add('card__swatch-button--active');
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CardSwatchSelector());
} else {
  new CardSwatchSelector();
}

